module.exports = __webpack_public_path__ + "static/media/user.edcb335f.svg";